import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.scss';
import Logo from '../../assets/logo-cabinet.png-_1_.webp';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const servicePaths = [
    '/la-neuropsychologie',
    '/bilan-neuropsychologique',
    '/accompagnements',
    '/psychotherapie'
  ];

  const isServiceActive = servicePaths.includes(location.pathname);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeAll = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  };

  return (
    <header className="navbar-header">
      <nav className="navbar container">
        <Link to="/" className="logo" onClick={closeAll}>
          <img className='image-logo' src={Logo} alt='Marie Guennec - Psychologue & Neuropsychologue'/>
          <span className="title">Marie Guennec</span>
          <span className="subtitle">Psychologue & Neuropsychologue</span>
        </Link>

        {/* Bouton Hamburger */}
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation */}
        <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <li>
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'active' : ''} 
              onClick={closeAll}
            >
              Accueil
            </Link>
          </li>

          <li>
            <Link 
              to="/qui-suis-je" 
              className={location.pathname === '/qui-suis-je' ? 'active' : ''} 
              onClick={closeAll}
            >
              Qui suis-je ?
            </Link>
          </li>

          {/* 💻 DESKTOP ONLY : Menu Déroulant "Prestations" */}
          <li 
            className={`dropdown desktop-only ${isDropdownOpen ? 'open' : ''}`}
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <button 
              className={`dropdown-btn ${isServiceActive ? 'active' : ''}`}
              aria-expanded={isDropdownOpen}
            >
              Prestations <span className="arrow">▾</span>
            </button>

            <ul className="dropdown-menu">
              <li>
                <Link 
                  to="/la-neuropsychologie" 
                  className={location.pathname === '/la-neuropsychologie' ? 'active' : ''} 
                  onClick={closeAll}
                >
                  La Neuropsychologie
                </Link>
              </li>
              <li>
                <Link 
                  to="/bilan-neuropsychologique" 
                  className={location.pathname === '/bilan-neuropsychologique' ? 'active' : ''} 
                  onClick={closeAll}
                >
                  Bilan Neuropsychologique
                </Link>
              </li>
              <li>
                <Link 
                  to="/accompagnements" 
                  className={location.pathname === '/accompagnements' ? 'active' : ''} 
                  onClick={closeAll}
                >
                  Les Accompagnements
                </Link>
              </li>
              <li>
                <Link 
                  to="/psychotherapie" 
                  className={location.pathname === '/psychotherapie' ? 'active' : ''} 
                  onClick={closeAll}
                >
                  La Psychothérapie
                </Link>
              </li>
            </ul>
          </li>

          {/* 📱 MOBILE ONLY : Liens à plat (Format original) */}
          <li className="mobile-only">
            <Link 
              to="/la-neuropsychologie" 
              className={location.pathname === '/la-neuropsychologie' ? 'active' : ''} 
              onClick={closeAll}
            >
              La Neuropsychologie
            </Link>
          </li>
          <li className="mobile-only">
            <Link 
              to="/bilan-neuropsychologique" 
              className={location.pathname === '/bilan-neuropsychologique' ? 'active' : ''} 
              onClick={closeAll}
            >
              Bilan Neuropsychologique
            </Link>
          </li>
          <li className="mobile-only">
            <Link 
              to="/accompagnements" 
              className={location.pathname === '/accompagnements' ? 'active' : ''} 
              onClick={closeAll}
            >
              Les Accompagnements
            </Link>
          </li>
          <li className="mobile-only">
            <Link 
              to="/psychotherapie" 
              className={location.pathname === '/psychotherapie' ? 'active' : ''} 
              onClick={closeAll}
            >
              La Psychothérapie
            </Link>
          </li>

          <li>
            <Link 
              to="/tarifs" 
              className={location.pathname === '/tarifs' ? 'active' : ''} 
              onClick={closeAll}
            >
              Tarifs
            </Link>
          </li>

          <li>
            <a 
              href="https://www.ibookthedate.fr/psychologue/44830-bouaye/marie-guennec" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-rdv"
            >
              Prendre RDV
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;